import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
    validateCapitalUnderline
} from '@/util/validate'



export const engineerClassifyOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "分类名称",
            prop: "name",
            type: "input",
            search: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入分类名称"
            }]
        },
        {
            label: "一级分类",
            prop: "superiorId",
            hide: true, 
            solt: true,
            formsolt: true
        },
        {
            label: "一级分类",
            prop: "superiorName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
       
    ]
};